var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-window"},[(!_vm.error)?_c('div',{staticClass:"b21"},[_vm._v(_vm._s(_vm.$t("AUTH_OAUTH_SIGNING_IN")))]):[_c('p',{staticClass:"login-alerts"},[_vm._v(_vm._s(_vm.errorText))]),_c('router-link',{attrs:{"to":"/auth/login"}},[_vm._v(_vm._s(_vm.$t("AUTH_COMMON_SIGNIN_TO")))])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }